import React from "react";
import Cookies from "js-cookie";


export function storeLoggedIn(data) {
    Cookies.set("loggedIn", data, { expires: 1 }); // Expires in 7 days
}

export function getLoggedIn() {
    return Cookies.get("loggedIn"); // Expires in 7 days
}

export function storeUserId(data) {
    Cookies.set("user_Id", data, { expires: 1 }); // Expires in 7 days
}

export function storeRoleId(data) {
    Cookies.set("role_Id", data, { expires: 1 }); // Expires in 7 days
}

export function getUserId() {
    return Cookies.get("user_Id"); // Expires in 7 days
}
export function getRoleId() {
    return Cookies.get("role_Id"); // Expires in 7 days
}

export function storeUser(data) {
    Cookies.set("user", JSON.stringify(data), { expires: 1 }); // Expires in 7 days
}

export function getUser() {
    return Cookies.get("user"); // Expires in 7 days
}
export function getRoleid() {
    return Cookies.get("user"); // Expires in 7 days
}
export function storeRoleName(data) {
    Cookies.set("roleName", data, { expires: 1 }); // Expires in 7 days
}

export function getRoleName() {
    return Cookies.get("roleName"); // Expires in 7 days
}

export function storeToken(data) {
    Cookies.set("token", data, { expires: 1 }); // Expires in 7 days
}

export function getToken() {
    return Cookies.get("token"); // Expires in 7 days
}

export function storeUserLogin() {
    Cookies.set("userLogin", "true", { expires: 1 }); // Expires in 7 days
}

export function getUserLogin() {
    return Cookies.get("userLogin"); // Expires in 7 days
}

export function removeUserLogin() {
    return Cookies.remove("userLogin"); // Expires in 7 days
}

export function removeAllCookies() {
    Cookies.remove("loggedIn")
    Cookies.remove("user_Id")
    Cookies.remove("role_id")
    Cookies.remove("user")
    Cookies.remove("roleName")
    Cookies.remove("token")
    Cookies.remove("userLogin")
};

export function removeAllSession() {
    sessionStorage.removeItem("cartId")
    sessionStorage.removeItem("eventName")
    sessionStorage.removeItem("email")
    sessionStorage.removeItem("isAtAllEvents")
    sessionStorage.removeItem("cart")
    sessionStorage.removeItem("eventTaxes")
    sessionStorage.removeItem("event_id")
    sessionStorage.removeItem("city_tax")
    sessionStorage.removeItem("state_tax")
    sessionStorage.removeItem("preorderStartDate")
}
